// Production configuration that works in all environments
const getApiUrl = () => {
  // Always prefer environment variable if set
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // For browser runtime, use current origin (works for all deployment environments)
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return window.location.origin;
  }
  
  // Local development fallback
  return 'http://localhost:8001';
};

export const API_URL = getApiUrl();
export const AUTH_URL = process.env.REACT_APP_AUTH_URL || 'https://auth.emergentagent.com';
